/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetsMelcoModelsCustomWarning
 */
export interface AssetsMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function AssetsMelcoModelsCustomWarningFromJSON(json: any): AssetsMelcoModelsCustomWarning {
    return AssetsMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function AssetsMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function AssetsMelcoModelsCustomWarningToJSON(value?: AssetsMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


